<template>
  <b-card
    :class="{panelHover: hover && !panelconfig.noHover}"
    no-body
    style="height: 100%; width: 100%; margin: 0; padding: 0;"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <b-card-title
      v-if="!panelconfig.noHover"
      class="mt-2 ml-2"
    >
      Statistic Card Vertical
    </b-card-title>

    <!-- Meta Info -->
    <div
      v-if="panelconfig.noHover"
      class="d-flex mt-1 small text-muted justify-content-between "
    >
      <b-col
        class="text-left"
      >
        <b-col
          v-if="edit"
          class="text-right"
        >
          <feather-icon
            v-if="edit"
            icon="EditIcon"
            class="text-primary cursor-pointer mr-2"
            size="18"
            variant="primary"
            @click="$emit('editPanel')"
          />
          <feather-icon
            v-if="edit"
            icon="XCircleIcon"
            class="text-danger cursor-pointer"
            size="20"
            variant="danger"
            @click="$emit('removeItem')"
          />
        </b-col>
      </b-col></div>

    <!-- Body -->
    <b-card-body>
      <BTable
        striped
        responsive
        :fields="localFields"
        :items="items"
      />
    </b-card-body>

    <!-- Footer -->
    <div
      v-if="panelconfig.noHover"
      class="d-flex mb-1 small text-muted"
    />
    <div
      v-if="doesNotExist"
      class="overlay d-flex flex-column justify-content-center align-items-center"
    >
      <p>
        The data source does not exist
      </p>
      <p v-if="edit">
        <b-button
          variant="danger"
          size="sm"
          class="mt-1"
          @click="$emit('removeItem')"
        >
          Remove Panel
        </b-button>
      </p>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardBody,
  BCardTitle,
  BCol,
  BButton,
  BTable,
} from 'bootstrap-vue'
import { API } from 'aws-amplify'
import * as queries from '@/graphql/queries'

export default {
  components: {
    BCard,
    BCardBody,
    BCardTitle,
    BCol,
    BButton,
    BTable,
  },
  props: {
    panelconfig: {
      type: Object,
      default: () => ({
        dataSources: [],
        fields: [],
        icon: {
          title: '',
          id: '',
        },
        color: '',
        hover: false,
      }),
    },
    edit: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      hover: false,
      statistic: 'Loading',
      showInfo: false,
      doesNotExist: false,
      items: [],
      devices: [],
      objects: [],
      sites: [],
      localFields: [],
    }
  },
  watch: {
    panelconfig: {
      handler(newVal) {
        this.localFields = newVal.fields
        this.updateLocalFieldsAndItems(newVal.dataSources[0])
      },
      deep: true,
    },
  },
  created() {
    this.getData()
    this.updateLocalFieldsAndItems(this.panelconfig.dataSources[0])
  },
  methods: {
    async getData() {
      try {
        const workspace = JSON.parse(localStorage.getItem('workspace')).id
        const getWorkspaceResponse = await API.graphql({
          query: queries.getWorkspace,
          variables: { id: workspace },
        })
        this.devices = getWorkspaceResponse.data.getWorkspace.devices.items
        this.objects = getWorkspaceResponse.data.getWorkspace.objects.items
        this.sites = getWorkspaceResponse.data.getWorkspace.sites.items
        this.updateLocalFieldsAndItems(this.panelconfig.dataSources[0])
      } catch (error) {
        // console.error('Error fetching data:', error)
      }
    },
    updateLocalFieldsAndItems(dataSource) {
      let newFields = []
      if (dataSource === 'device' && this.devices.length > 0) {
        newFields = Object.keys(this.devices[0])
        this.items = this.devices
      } else if (dataSource === 'object' && this.objects.length > 0) {
        newFields = Object.keys(this.objects[0])
        this.items = this.objects
      } else if (dataSource === 'site' && this.sites.length > 0) {
        newFields = Object.keys(this.sites[0])
        this.items = this.sites
      }
      this.localFields = newFields
      this.$emit('update-panelconfig-fields', newFields) // Emit the new fields to the parent component
    },
  },
}
</script>
  <style lang="scss">
  .panelHover {
    position: relative;
     width: 100%; /* Full width (cover the whole page) */
    height: 100%; /* Full height (cover the whole page) */
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
    z-index: 0; /* Specify a stack order in case you're using a different order for other elements */
    cursor: pointer; /* Add a pointer on hover */
  }
  .textCenter {
    text-align: center;
  }
  .overlay {
    z-index: 1000;
    position: relative;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(5px); /* Add blur effect */
    color: #fff;
  }
  </style>
